export default class BsAccordion {
  constructor(dom) {
    this.dom = dom;
    this.id = this.dom.getAttribute("id");
    this.items = this.dom.querySelectorAll(".accordion-item");
    for (let [index, item] of this.items.entries()) {
      let h4 = item.querySelector("h4");
      h4.classList.add("accordion-header");
      h4.setAttribute("id", `${this.id}-heading-${index}`);
      let button = document.createElement("button");
      button.classList = "accordion-button collapsed";
      button.setAttribute("type", "button");
      button.setAttribute("data-bs-toggle", "collapse");
      button.setAttribute("data-bs-target", `#${this.id}-collapse-${index}`);
      button.setAttribute("aria-expanded", "false");
      button.setAttribute("aria-controls", `${this.id}-collapse-${index}`);
      button.innerHTML = h4.innerHTML;
      h4.innerHTML = "";
      h4.append(button);

      let bodyContent = item.querySelector(".accordion-body");
      let bodyWrap = document.createElement("div");
      bodyWrap.classList = "accordion-collapse collapse";
      bodyWrap.setAttribute("id", `${this.id}-collapse-${index}`);
      bodyWrap.setAttribute("aria-labelledby", `${this.id}-collapse-${index}`);
      bodyWrap.setAttribute("data-bs-parent", `#${this.id}`);
      bodyContent.parentNode.insertBefore(bodyWrap, bodyContent);
      bodyWrap.appendChild(bodyContent);
    }
  }
}
